webpackJsonp([35783957827783],{

/***/ 354:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.pageQuery = exports.default = undefined;
	
	var _class, _temp;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _graphql = __webpack_require__(35);
	
	var _graphql2 = _interopRequireDefault(_graphql);
	
	var _seo = __webpack_require__(38);
	
	var _seo2 = _interopRequireDefault(_seo);
	
	var _pageHelpers = __webpack_require__(40);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var IndexPage = (_temp = _class = function (_React$Component) {
	  _inherits(IndexPage, _React$Component);
	
	  function IndexPage() {
	    _classCallCheck(this, IndexPage);
	
	    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
	  }
	
	  IndexPage.prototype.componentDidMount = function componentDidMount() {
	    (0, _pageHelpers.initPageElements)();
	  };
	
	  IndexPage.prototype.render = function render() {
	    var _props$data = this.props.data,
	        site = _props$data.site,
	        homePage = _props$data.homePage;
	
	
	    return _react2.default.createElement(
	      'div',
	      null,
	      _react2.default.createElement(_seo2.default, { currentPage: homePage, location: this.props.location, siteMeta: site.siteMeta }),
	      _react2.default.createElement('div', {
	        dangerouslySetInnerHTML: { __html: homePage.content } // eslint-disable-line react/no-danger
	      })
	    );
	  };
	
	  return IndexPage;
	}(_react2.default.Component), _class.propTypes = {
	  data: _propTypes2.default.object.isRequired,
	  location: _propTypes2.default.object.isRequired
	}, _temp);
	exports.default = IndexPage;
	var pageQuery = exports.pageQuery = '** extracted graphql fragment **';

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-index-js-9ee397c2f422566b8193.js